import copy from 'copy-to-clipboard'

export const getClipboardOnClick = (url: string) => () => {
    copy(url)
}
